import type { ConditionalContent } from '../../domain';
import { useValidateConditionalContentLength } from './useValidateConditionalContentLength';

export const useValidateConditionalContent = () => {
  const validateHandlebarsSyntaxInContent = useValidateConditionalContentLength();
  return (conditionalContent?: ConditionalContent) =>
    validateHandlebarsSyntaxInContent(conditionalContent); // Add future top-level validations here
};
